import * as React from 'react';
import { LogotypesProps, slidesPerView } from './logotypes';
import { Logotype } from './logotypeImg';
import { LogotypesDisplay } from '../../empracoTypes';
import { FaIcon } from '../../generic/icon';

export function LogotypesGrid(props: LogotypesProps) {
  const {
    mediaObjects,
    display,
    filterColor,
    externalLink,
    logotypesPerView,
    maxHeight,
    spaceBetween,
    buttonLabel
  } = props.data;

  const [cap, setCap] = React.useState<number | null>(null);

  const spv = slidesPerView(logotypesPerView);
  const gap = spaceBetween ?? 20;
  const flex = 100 / spv;

  React.useEffect(() => {
    if (display === LogotypesDisplay.partiallyHiddenGrid) {
      setCap(spv);
      return;
    }
  }, [spv]);

  // Applies a "margin" between the items on each row to make them fit the entire container.
  const offset = (gap * spv - gap) / spv;

  return(
    <div className='empori-logotypes-grid element-flex' style={{ gap }}>
      {mediaObjects.slice(0, cap ? cap : mediaObjects.length).map((item, index) =>
        <Logotype
          key={index}
          {...item}
          externalLink={externalLink ?? false}
          filterColor={filterColor}
          maxHeight={maxHeight}
          parentStyling={{flex: `0 0 calc(${flex}% - ${offset}px)`}} />)}
      {display === LogotypesDisplay.partiallyHiddenGrid && !!cap &&
        <div
          className='empori-buttons-container element-flex align-center'
          onClick={() => setCap(null)}>
          <span className='empori-button'>
            {buttonLabel ?? 'See all'}
            <i className='fa-regular fa-chevron-down'></i>
          </span>
        </div>}
    </div>
  );
}